<h1 mat-dialog-title>Session beendet</h1>
<div mat-dialog-content>Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true">OK</button>
</div>
